exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul a {\n  color: #aaaaaa; }\n  ul a:hover {\n    color: #ffffff;\n    text-decoration: none; }\n\n.nav-feedback {\n  margin-bottom: 8px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/app-sys-utilz/app-sys-utilz.component.scss
// module id = ../../../../../src/app/components/app-sys-utilz/app-sys-utilz.component.scss
// module chunks = main